var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.browserInvalid)?_c('div',{staticClass:"browser-check-bar"},[_c('span',[_vm._v(_vm._s(_vm.translate('invalid_browser')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }